import { 
    Hub, 
    Settings, 
    SupportAgent, 
    ViewList, 
    People, 
    Extension, 
    Article, 
    SvgIconComponent, 
    Label, 
    Abc, 
    Key, 
    Api,
    PictureAsPdf,
    Create,
    Edit,
    Link,
    Image,
    TextFields,
    VerifiedUser,
    Person,
    Group,
    Password,
    ApiOutlined
} from "@mui/icons-material";
import { PropertyType } from "../types/PropertyType";

export const GeneralIcons : {[key:string]: SvgIconComponent} = {
    Create: Create,
    Edit: Edit,
    Default: Article
}

export const getGeneralIcon = (key: string) => {
    return GeneralIcons.hasOwnProperty(key) ? GeneralIcons[key] : GeneralIcons.Default; 
}

export const AppIcons : {[key:string]: SvgIconComponent} = {
    Services: Hub,
    Extensions: Extension,
    Settings: Settings,
    Support: SupportAgent,
    List: ViewList,
    Users: People,
    Api: ApiOutlined,

    DefaultListItem: Label,
    DefaultTextInput: Abc,
    Default: Article
}

export const getAppIcon = (key: string) => {
    return AppIcons.hasOwnProperty(key) ? AppIcons[key] : AppIcons.Default; 
}

export const ServiceIcons : {[key: string]: SvgIconComponent} = {
    "fortnox-invoice-pdf": PictureAsPdf,
    "hogia-invoice-pdf": PictureAsPdf,
    "business-central-invoice-pdf": PictureAsPdf,
    "fortnox-invoice-pdf-v2": PictureAsPdf,
    Default: Api
}

export const getServiceIcon = (key: string) => {
    return ServiceIcons.hasOwnProperty(key) ? ServiceIcons[key] : ServiceIcons.Default; 
}

export const PropertyIcons : {[key: number]: SvgIconComponent} = {
    [PropertyType.UUID]: Key,
    [PropertyType.NAME]: Abc,
    [PropertyType.LINK]: Link,
    [PropertyType.IMAGE]: Image,
    [PropertyType.TEXT]: TextFields,
    [PropertyType.PASSWORD]: Password,
    [PropertyType.UNKNOWN]: Article
}

export const getPropertyIcon = (key: PropertyType) => {
    return PropertyIcons.hasOwnProperty(key) ? PropertyIcons[key] : PropertyIcons[PropertyType.UNKNOWN]; 
}

export const UserIcons : {[key: string]: SvgIconComponent} = {
    ADMIN: VerifiedUser,
    CUSTOMER: Person,

    GROUP: Group
}

export const getUserIcon = (key: string) => {
    return UserIcons.hasOwnProperty(key) ? UserIcons[key] : UserIcons.CUSTOMER;  
}